const initialState = {
  token: null,
  refreshToken: null,
  currentUser: null,
  isAuthenticated: false,
  role: null,
};

export function AuthReducer(state = initialState, action) {
  switch (action.type) {
    case "SIGN_UP":
      return {
        token: action.payload.token,
        refreshToken: action.payload.refreshToken,
        currentUser: action.payload.currentUser,
        isAuthenticated: true,
        role: "Student",
      };

    case "SIGN_IN":
      return {
        token: action.payload.token,
        refreshToken: action.payload.refreshToken,
        currentUser: action.payload.currentUser,
        isAuthenticated: true,
        role: action.payload.role,
      };

    case "UPDATE_USER_PROFILE":
    return {
      ...state,
      currentUser: {
        ...state.currentUser,
        ...action.payload
      }
    };

    case "LOGOUT":
      return initialState;
    default:
      break;
  }
  return state;
}
